/*
 * Copyright (c) 2025 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { PureAbility, AbilityBuilder } from '@casl/ability';
import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { ACTION_PERMITS_LIST, FEATURE_PERMITS_LIST, SCREEN_PERMITS_LIST, Permit } from './permits';

export type Actions = 'viewScreen' | 'access' | 'perform';
export type Subjects = Permit;
export type AppAbility = PureAbility<[Actions, Subjects]>;

export const AppAbilityContext = createContext<AppAbility>(new PureAbility<[Actions, Subjects]>());
export const Can = createContextualCan(AppAbilityContext.Consumer);

export default function defineAppAbilityByPermits(permits: Permit[]): AppAbility {
    const { can, build } = new AbilityBuilder<AppAbility>(PureAbility);

    SCREEN_PERMITS_LIST.forEach((item) => {
        if (permits.includes(item)) can('viewScreen', item);
    });

    FEATURE_PERMITS_LIST.forEach((item) => {
        if (permits.includes(item)) can('access', item);
    });

    ACTION_PERMITS_LIST.forEach((item) => {
        if (permits.includes(item)) can('perform', item);
    });

    return build();
}
